// Rocell brand colors derived from /media/logos/default.svg
export const ROCELL_COLORS = {
  primary: '#EF305E',
  primaryDark: '#D4284F',
  navy: '#0D2451',
  accent: '#FF870D',
  muted: '#7E8299',
  light: '#F4F4F4',
  tableHeader: '#E8ECF3',
  white: '#FFFFFF',
  brandBlue: '#02158B',
  brandBlueDark: '#010F6B',
  brandBlueLight: '#3B56C4',
  brandBlueSurface: '#E8EBF7',
}

// On Time Arrangement chart (Arranged / Not arranged)
export const OTA_CHART_COLORS = ['#1c2fa6', '#FF8305']

// Blue/green pair used on On Time Delivery chart
export const OTA_OTD_CHART_COLORS = ['#008FFB', '#00E396']

// Vehicle Utilization chart bar color
export const VUT_CHART_COLORS = ['#1c2fa6']

export const CHART_PALETTE = [
  '#EF305E',
  '#0D2451',
  '#FF870D',
  '#50CD89',
  '#7239EA',
  '#009EF7',
  '#FFC700',
  '#3F4254',
]
